/* eslint id-length: [2, {"exceptions":["a","b"]}] */
import mori from 'mori';
// import { getDefaultStates } from '../config/table';
import { buildRowData, getAgColumns } from './table';

export function filterMetaDataByTimeframe(data, options) {
  const { metaData } = data;

  // If no metaData, we are rendering a Medicare indicator
  if (!metaData) {
    const {
      columns,
      immutableDataviews,
      immutableHeaders,
      immutableDistributions,
    } = data;

    return {
      columns,
      immutableDataviews,
      immutableHeaders,
      immutableDistributions,
    };
  }

  const {
    activeTab,
    startTimeframe,
    currentTimeframe,
  } = options;
  let activeTimeframe = +(currentTimeframe || 0);
  activeTimeframe = activeTab === 'graph' && !startTimeframe ?
    0 : activeTimeframe;

  const metaDataYear = data.timeframes[activeTimeframe];

  return metaData[metaDataYear];
}

/**
 * [filterByTimeframe description]
 * @TODO build out doc
 * @param  {[type]} data    [description]
 * @param  {[type]} options [description]
 * @return {[type]}         [description]
 */
export function filterByTimeframe(data, options) {
  // Get the list of selected timeframes by name
  // @TODO logic for selecting by timeframe gets a little weird for defaults
  // and range vs single, could refactor this
  let activeTimeframe = +(options.currentTimeframe || 0);
  let endTimeframeOffset = 1;
  if (options.activeTab === 'graph') {
    if (!options.startTimeframe) {
      activeTimeframe = 0;
    }
    const startTimeframe = +(options.startTimeframe || 0) + 1;
    endTimeframeOffset = options.startTimeframe ?
      startTimeframe :
      data.timeframes.length;
  } else {
    endTimeframeOffset = +(options.startTimeframe || activeTimeframe + 1);
  }

  const timeframes = mori.set((data.timeframes || [0]).slice(
    activeTimeframe,
    endTimeframeOffset
  ));

  return mori.filter(
    (sheet) => mori.hasKey(timeframes, mori.first(sheet)),
    data.immutableData
  );
}

/**
 * [buildTable description]
 * @TODO build out doc
 * @param  {[type]} data            [description]
 * @param  {[type]} options         [description]
 * @param  {[type]} timeframes      [description]
 * @param  {[type]} combinedColumns [description]
 * @param  {[type]} selectedSetKeys [description]
 * @param  {[type]} distributions   [description]
 * @param  {[type]} dataviewType    [description]
 * @param  {[type]} columnKeys      [description]
 * @param  number   tableIndex      Number identifying which table this is in a page with many tables
 * @return {[type]}                 [description]
 */
export function buildTable(
  data,
  metaData,
  options,
  timeframes,
  combinedColumns,
  selectedSetKeys,
  distributions,
  dataviewType,
  columnKeys,
  tableIndex
) {
  const trend = mori.count(timeframes) > 1;

  const geoMulti = mori.getIn(
    data.config,
    ['globalRules', 'Geomulti'],
    false
  );

  const mapBaseColumn = mori.getIn(
    data.config,
    ['globalRules', 'Map Base Column'],
    false
  );

  const linkContext = mori.getIn(
    data.config,
    ['globalRules', 'Context'],
    []
  )[1] || 'states';

  // Will be passed into cellRenderer to check for existance of footnotes for each cell
  const baseContext = mori.getIn(
    data.config,
    ['globalRules', 'Context'],
    []
  )[0] || false;

  const builtRowData = buildRowData(
    timeframes,
    selectedSetKeys,
    combinedColumns,
    trend
  );

  // Build the column headers and variables for agGrid
  const columnDefs = getAgColumns(
    metaData.immutableHeaders,
    distributions,
    mori.getIn(data.config, ['globalRules', 'Link Column'], false),
    mori.getIn(data.config, ['globalRules', 'Link Target'], false),
    linkContext,
    dataviewType,
    timeframes,
    trend,
    mori.first(columnKeys[0]),
    geoMulti && mapBaseColumn ? mapBaseColumn : false,
    geoMulti,
    baseContext,
    tableIndex
  );

  return mori.hashMap(
    'tableData', mori.hashMap(
      'rowData', builtRowData.rowData || [],
      'columnDefs', columnDefs,
      'selectedSetKeys', selectedSetKeys
    )
  );
}



// WEBPACK FOOTER //
// ../datacenter/app/js/services/dataFromOptions.js